import React from 'react';

export class Clock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: '',
    };
  }

  componentDidMount() {
    this.tick(); // Initial call
    this.intervalID = setInterval(() => this.tick(), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  tick() {
    const lng = this.props.lang;
    const locale = lng === 'ar' ? 'ar-OM' : 'en-US';
    const now = new Date();

    // Get date parts
    const dateParts = new Intl.DateTimeFormat(locale, {
      timeZone: 'Asia/Muscat',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(now);

    const day = dateParts.find((part) => part.type === 'day').value;
    const month = dateParts.find((part) => part.type === 'month').value;
    const year = dateParts.find((part) => part.type === 'year').value;

    // Get time in 12-hour format with AM/PM
    const time = now.toLocaleTimeString(locale, {
      timeZone: 'Asia/Muscat',
      hour12: true,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });

    // Format: DD-MM-YYYY HH:MM:SS AM/PM
    const formattedDateTime = `${day}-${month}-${year} ${time}`;

    this.setState({
      time: formattedDateTime,
    });
  }

  render() {
    return this.state.time || 'Loading...';
  }
}
